import { DocumentType } from '@/types/schema';

import {
  BUSINESS_DOCUMENT_TYPES,
  BUSINESS_QUESTIONS,
  HEALTH_CARE_DOCUMENT_TYPES,
  HEALTH_CARE_QUESTIONS,
  OTHER_QUESTIONS,
  TRUST_DOCUMENT_TYPES,
  TRUST_QUESTIONS,
  WILL_DOCUMENT_TYPES,
  WILL_QUESTIONS,
} from './DocumentChatEmptyState.constants';

export function getQuestionsForDocumentType(
  documentType: DocumentType | null | undefined
): string[] {
  if (!documentType) {
    return OTHER_QUESTIONS;
  }

  if (TRUST_DOCUMENT_TYPES.has(documentType)) {
    return TRUST_QUESTIONS;
  }

  if (WILL_DOCUMENT_TYPES.has(documentType)) {
    return WILL_QUESTIONS;
  }

  if (HEALTH_CARE_DOCUMENT_TYPES.has(documentType)) {
    return HEALTH_CARE_QUESTIONS;
  }

  if (BUSINESS_DOCUMENT_TYPES.has(documentType)) {
    return BUSINESS_QUESTIONS;
  }

  return OTHER_QUESTIONS;
}
